import { useAuth } from "@/lib/auth/use-auth";
import { useReleaseHijack } from "@/lib/auth/hijack-queries";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function HijackBanner() {
  const { isHijacked, user } = useAuth();
  const release = useReleaseHijack();
  const navigate = useNavigate();

  if (!isHijacked) return null;

  function handleRelease() {
    release.mutate(undefined, {
      onSuccess: () => navigate("/"),
    });
  }

  return (
    <div className="flex items-center justify-between bg-amber-500 px-4 py-2 text-sm font-medium text-white">
      <span>
        You are viewing as <strong>{user?.full_name || "another user"}</strong>
      </span>
      <Button
        variant="outline"
        size="sm"
        className="border-white bg-transparent text-white hover:bg-amber-600 hover:text-white cursor-pointer"
        onClick={handleRelease}
        disabled={release.isPending}
      >
        {release.isPending ? "Releasing..." : "End Session"}
      </Button>
    </div>
  );
}
